<template>
  <div
    class="sailor"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.3)"
  >
    <div class="sailor-title">
      <p>精彩分享</p>
      <div style="display: flex; margin-right: 8px">
        <el-input
          class="sailor-input"
          placeholder="请输出标题或者内容"
          v-model="mediaName"
        ></el-input>
        <div class="search-sailor" @click="searchSailor">
          <img src="@/assets/search-sailor.png" alt="" />
        </div>
      </div>
    </div>
    <div class="crew-video">
      <div class="viedo-list">
        <div
          v-for="(item, index) in viedoList"
          :key="index"
          class="viedo-one"
          @click="openViedo(item)"
        >
          <div class="viedo-img"><img :src="item.picUrl" alt="" /></div>
          <div class="video-font" :title="item.mediaName">
            {{ item.mediaName }}
          </div>
          <div class="video-mess">
            <div class="video-user">海事局</div>
            <div class="video-time">{{ item.uploadTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-messages" v-if="viedoList.length == 0">
      <img src="@/assets/none-mess.png" alt="" />
      <p>暂无数据</p>
    </div>
    <div class="page-aiton" v-if="viedoList.length > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="dialog-color dialog-viedo"
      width="60.7143rem"
      :title="viedoTitle"
      :visible.sync="videoVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <div class="video-up">
        <video :src="videoUrl" autoplay controls ref="vueRef"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//getAllFile
import { selecteMediaInfo, getAllFile } from "@/apis/index";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      photoList: [],
      viedoList: [],
      viedoTitle: "",
      videoVisible: false,
      videoUrl: "",
      urlStr: "",
      mediaName: "",
      loading: true,
      total: 0,
      pageNo: 1,
      picUrl: "",
      vidUrl: "",
      pageSize: 12,
    };
  },
  mounted() {},
  created() {
    this.selecteVideoInfoList();
  },
  methods: {
    async lookAllFileSrc(src) {
      // console.log(src);
      let url = await getAllFile({
        fileNameList: src,
      });
      return url.data;
    },
    async selecteVideoInfoList() {
      let res = await selecteMediaInfo({
        mediaType: "2",
        pageSize: "12",
        pageNo: this.pageNo,
        mediaName: this.mediaName,
        showMedia: "1",
      });
      this.vidUrl = "";
      this.picUrl = "";
      res.data.resultList.forEach((item) => {
        this.vidUrl +=
          item.mediaUrl[0] == "/"
            ? "file" + item.mediaUrl + ","
            : "file/" + item.mediaUrl + ",";
        this.picUrl +=
          item.pictureUrl[0] == "/"
            ? "file" + item.pictureUrl + ","
            : "file/" + item.pictureUrl + ",";
        // item.url = url.PromiseResult.data;
      });
      let vidLists = this.lookAllFileSrc(this.vidUrl);
      let picLists = this.lookAllFileSrc(this.picUrl);
      vidLists.then((result) => {
        this.vidList = result;
        // console.log(this.urlList);
        res.data.resultList.forEach((item, index) => {
          this.vidList.forEach((val, valIndex) => {
            if (index == valIndex) {
              item.vidUrl = val;
            }
          });
        });
      });
      picLists.then((result) => {
        this.picList = result;
        // console.log(this.urlList);
        res.data.resultList.forEach((item, index) => {
          this.picList.forEach((val, valIndex) => {
            if (index == valIndex) {
              item.picUrl = val;
            }
          });
        });
      });
      this.total = res.data.rowCount;
      let that = this;
      setTimeout(() => {
        that.viedoList = res.data.resultList;
        that.loading = false;
      }, 500);
      // this.formPhoto = res.data;
      // console.log(this.photoList);
      // this.lookFileSrc(res.data.pictureUrl);
    },
    searchSailor() {
      this.loading = true;
      this.pageNo = 1;
      this.selecteVideoInfoList();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.loading = true;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.selecteVideoInfoList();
    },
    openViedo(item) {
      // console.log(item);
      this.viedoTitle = item.mediaName;
      this.videoUrl = item.vidUrl;
      this.videoVisible = true;
    },
    handleClose() {
      this.videoVisible = false;
      this.$refs.vueRef.pause(); //暂停
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
